import AnimationClip, { AnimationClipEvent } from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Point from '../../../Utility/Point';
import {
    StartAnimationClip,
    AwaitIterators,
    PlayAnimation,
} from '../AnimationHelper';
import Game from '../../../Game';
import Scene from '../../../Scene/Scene';
import { TimerActions } from '../../../State/Timer/TimerActions';
import { TimerType } from '../../Timer/TimerTypes';
import Overlay from '../../../Prototype/UI/Overlay';
import Text from '../../../Prototype/Text';
import HarvestButton from '../../../Prefabs/UI/HUD/HarvestButton';
import { AlphaText } from 'System/Animation/Clip/AlphaText';
import { OverlayFadeIn } from 'System/Animation/Clip/OverlayFadeIn';
import { Alpha } from 'System/Animation/Clip/Alpha';
import { ArrowBounceLoop } from 'System/Animation/Clip/ArrowBounceLoop';
import Renderable from 'Component/Renderable';
import { ListenerFn } from 'eventemitter3';

type Meta = {
    mainContainer: GameObject;
    harvestButton: HarvestButton;
};

export class ShowFTUXFieldUnlock extends AnimationClip<Meta> {
    public* execute(HUD: GameObject, meta: Meta): IterableIterator<number> {
        TimerActions.updateTimer({
            timer: TimerType.HARVEST,
            time: null,
        });

        const scene: Scene = Game.scene.getActiveScene();

        let harvestMenuOpened: boolean = false;
        scene.on('HideHarvestFUTX', () => {
            Game.scene
                .getActiveScene()
                .off('HideHarvestFUTX', this.complete.bind(this));
            harvestMenuOpened = true;
        });
        scene.emit('TransitionCrops');

        meta.harvestButton.setInteractive(true);

        const overlay: Overlay = GameObject.Instantiate(Overlay, {
            preventInteraction: true,
            anchors: [0.5, 0.5, 0.5, 0.5],
            alpha: 0,
            color: [0, 0, 0, 225],
        });
        meta.mainContainer.addChild(overlay);
        meta.mainContainer.addChild(meta.harvestButton);

        StartAnimationClip(new OverlayFadeIn(overlay));

        const harvestTextName: string = 'ftux_harvest_text';
        const harvestText: Text = GameObject.Instantiate(Text, {
            name: harvestTextName,
            alpha: 0,
            style: {
                ...Game.style.getStyle('ftux.text'),
                fontSize: 72,
            },
            text: Game.locale.getText('FTUX_Harvest_Text'),
            anchor: new Point(0.5, 0.5),
            scale: new Point(1, 1),
            bounds: new Point(1200, 600),
            relativePosition: new Point(0.5, 0.5),
        });
        overlay.addChild(harvestText);

        const arrow = meta.harvestButton.ftuxArrow;
        arrow.getComponent(Renderable).visible = true;

        const arrowAlphaClip = new Alpha(arrow, {
            startAlpha: 0,
            endAlpha: 1,
            duration: 450,
        });

        arrowAlphaClip.on(AnimationClipEvent.COMPLETE, () => {
            StartAnimationClip(new ArrowBounceLoop(arrow, {
                speed: 400,
                offset: new Point(25, 20),
            }));
        });

        StartAnimationClip(arrowAlphaClip);

        StartAnimationClip(
            new Alpha(overlay, {
                startAlpha: 0,
                endAlpha: 0.9,
                duration: 450,
            }),
        );

        StartAnimationClip(
            new Alpha(meta.harvestButton.root, {
                startAlpha: 0,
                endAlpha: 1,
                duration: 450,
            }),
        );

        StartAnimationClip(
            new AlphaText(harvestText, {
                startAlpha: 0,
                endAlpha: 1,
                duration: 450,
            }),
        );

        while (!harvestMenuOpened) {
            yield;
        }

        const fn: ListenerFn = () => {
            scene.off('HideHarvestFUTX', fn);
            arrow.destroy();
            overlay.destroy();
            harvestText.destroy();
        };
        scene.on('HideHarvestFUTX', fn);
        const elements = [arrow, overlay];
        yield* AwaitIterators(
            elements.map(element => {
                return PlayAnimation(
                    new Alpha(element, {
                        startAlpha: 1,
                        endAlpha: 0,
                        duration: 450,
                    })
                );
            }
        ));
        elements.forEach(element => element.destroy());
        return;
    }
}
